// extracted by mini-css-extract-plugin
export default {"coverLink":"bL-z","contentBox":"cL-z","zapposPromoContainer":"dL-z","zapposPromoGroupContainer":"eL-z","promos":"fL-z","bottom":"gL-z","top":"hL-z","right":"iL-z","left":"jL-z"};